export default `/* Ids Tag List Component */
:host {
  margin: var(--ids-tag-list-margin);
  display: flex;
  flex-wrap: wrap;
}

::slotted(.ids-tag) {
  margin: var(--ids-tag-list-margin);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdGFnIiwic291cmNlcyI6WyJpZHMtdGFnLWxpc3Quc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0VBQ0U7RUFDQTtFQUNBOzs7QUFJRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIFRhZyBMaXN0IENvbXBvbmVudCAqL1xuOmhvc3Qge1xuICBtYXJnaW46IHZhcigtLWlkcy10YWctbGlzdC1tYXJnaW4pO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LXdyYXA6IHdyYXA7XG59XG5cbi8vIElkcyB0YWcgaGFzIGl0cyBvd24gbWFyZ2luLWlubGluZS1lbmRcbjo6c2xvdHRlZCguaWRzLXRhZykge1xuICBtYXJnaW46IHZhcigtLWlkcy10YWctbGlzdC1tYXJnaW4pO1xufVxuIl19 */`;
